import { render, staticRenderFns } from "./pgamehome.vue?vue&type=template&id=3f886d40&scoped=true&"
import script from "./pgamehome.vue?vue&type=script&lang=js&"
export * from "./pgamehome.vue?vue&type=script&lang=js&"
import style0 from "./pgamehome.vue?vue&type=style&index=0&id=3f886d40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f886d40",
  null
  
)

export default component.exports